import dayjs from 'dayjs';

const formatDateField = (value) => {
  if (!value || !dayjs(value).isValid()) {
    return null;
  }

  return dayjs(value).format('YYYY-MM-DD');
};

export const buildInvoicePeriodPayload = ({
  invoice_period_start_date,
  invoice_period_end_date,
  invoice_period_description,
}) => {
  const invoicePeriod = {};

  const startDate = formatDateField(invoice_period_start_date);
  if (startDate) {
    invoicePeriod.start_date = startDate;
  }

  const endDate = formatDateField(invoice_period_end_date);
  if (endDate) {
    invoicePeriod.end_date = endDate;
  }

  if (invoice_period_description) {
    invoicePeriod.description = invoice_period_description;
  }

  return invoicePeriod;
};
